module.exports = __webpack_public_path__ + "static/locations-desktop2-47b9b938e73d196525abf30ce1712af4.png";